import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { FeatureAccessService } from './feature-access.service';

@Injectable({ providedIn: 'root' })
export class FeatureAccessGuard implements CanActivate {
  constructor(private access: FeatureAccessService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.access.allows(route.data['roles'] ?? []) || this.router.createUrlTree(['/access-denied']);
  }
}
